import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Box,
} from '@mui/material';
import { DynamicFormBuilder } from '../../../base/SchemaFormBuilder';
import { BaseButton } from '../../../base';

export interface EditingConfigItem {
  schemaKey: string;
  data: Record<string, any>;
  schema: Record<string, any>;
  schemaType?: 'config' | 'collection';
}

export interface ConfigItemModalProps {
  open: boolean;
  editingItem: EditingConfigItem | null;
  saving: boolean;
  
  // Event handlers
  onClose: () => void;
  onSave: (formData: Record<string, any>) => void;
}

/**
 * Modal for editing configuration items
 * Uses DynamicFormBuilder for dynamic form rendering
 */
export const ConfigItemModal: React.FC<ConfigItemModalProps> = ({
  open,
  editingItem,
  saving,
  onClose,
  onSave,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        Edit Configuration: {editingItem?.schemaKey}
      </DialogTitle>

      <DialogContent dividers sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {editingItem?.schema && Object.keys(editingItem.schema).length > 0 ? (
          <Box sx={{ pt: 2 }}>
            <DynamicFormBuilder
              schema={editingItem.schema}
              initialData={editingItem.data}
              onSubmit={onSave}
              loading={saving}
            />
          </Box>
        ) : (
          <Alert severity="info">
            No schema defined for this configuration. Please check the config schema.
          </Alert>
        )}
      </DialogContent>

      <DialogActions>
        <BaseButton
          onClick={onClose}
          variant="outlined"
          colorVariant="secondary"
        >
          Cancel
        </BaseButton>
        <BaseButton
          variant="contained"
          colorVariant="primary"
          disabled={saving}
          isLoading={saving}
          loadingLabel="Saving..."
        >
          Save Configuration
        </BaseButton>
      </DialogActions>
    </Dialog>
  );
};

export default ConfigItemModal;
